(function () {
 
  var country = (window.VisitorCountry || "").toUpperCase();
  if (!country) return;

  var items = Array.isArray(window.CountryNotifications)
    ? window.CountryNotifications
    : [];
  if (!items.length) return;

  var match = items.find(function (x) {
    return (x.country_code || "").toUpperCase() === country;
  });
  if (!match || !match.message_html) return;

  var key = "popup_shown_" + country;

  try {
    if (localStorage.getItem(key) === "1") return;
  } catch (e) {}

  var modal = document.getElementById("cn-modal");
  var body = document.getElementById("cn-body");
  if (!modal || !body) return;

  body.innerHTML = match.message_html;

  function close() {
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    try { localStorage.setItem(key, "1"); } catch (e) {}
  }

  modal.classList.add("is-open");
  modal.setAttribute("aria-hidden", "false");

  modal.addEventListener("click", function (e) {
    if (e.target && e.target.hasAttribute("data-cn-close")) close();
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") close();
  }, { once: true });
})();
